import React from "react";
import Context from "../../../../../../context";
import { CustomButton2, CustomModal } from "../../../../../../components";
import "./index.scss";
import Saderat from "./../../../../../../../assets/images/saderat.png";
import Zarinpal from "./../../../../../../../assets/images/zarinpal.png";
import api from "../../../../../../api";
import utils from "../../../../../../utils";

type GateWay = "saderat" | "zarinpal";
const PayModal = () => {
  const { selectedDriver, showModal, setShowModal } = React.useContext(
    Context.DriverScreen
  );
  const [gateWay, setGateWay] = React.useState<GateWay>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {}, []);

  const payHandler = async () => {
    setIsLoading(true);
    const result = await api.post.common.getPayLink({
      serviceId: selectedDriver?._id,
      gateway: gateWay as string,
    });

    if (result) {
      utils.successHandler(Number(result.CODE));
      window.location.href = result?.result?.payLink;
    }
  };

  return (
    <section id="pay-modal">
      <CustomModal
        open={showModal === "PAY"}
        onClose={() => setShowModal!("DRIVER_PAY_SERVICES_PRICE")}
        overlayOpacity={"0.3"}
        minWidth={"20vw"}
        maxWidth={"30vw"}
      >
        <div className="price">
          <span>مبلغ قابل پرداخت : </span>
          <span className={"bold"}>50000 تومان</span>
        </div>
        <ul className="gateway-list">
          <li className="gateway-item" onClick={() => setGateWay("saderat")}>
            <label>
              <img src={Saderat} width={80} height={80} />
              <div className="gateway-item-text">درگاه بانک صادرات</div>
              <div>
                <input
                  type="radio"
                  name="test"
                  value="small"
                  checked={gateWay === "saderat"}
                />
              </div>
            </label>
          </li>
          <li className="gateway-item" onClick={() => setGateWay("zarinpal")}>
            <label>
              <img src={Zarinpal} width={80} height={80} />
              <div className="gateway-item-text">درگاه زرین پال</div>
              <div>
                <input
                  type="radio"
                  name="test"
                  value="small"
                  checked={gateWay === "zarinpal"}
                />
              </div>
            </label>
          </li>
        </ul>
        <CustomButton2
          title={"پرداخت"}
          onClick={payHandler}
          isLoading={isLoading}
        />
      </CustomModal>
    </section>
  );
};

export default PayModal;
